import { render, staticRenderFns } from "./GroupsLeagueCreateOrEdit.vue?vue&type=template&id=79441c96&scoped=true&"
import script from "./GroupsLeagueCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./GroupsLeagueCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupsLeagueCreateOrEdit.vue?vue&type=style&index=0&id=79441c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79441c96",
  null
  
)

export default component.exports